import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar from './components/layout/Sidebar';
import Login from './pages/Login';
import Convite from './pages/Convite';
import Dashboard from './pages/Dashboard';
import Operacoes from './pages/Operacoes';
import Jornada from './pages/Jornada';
import Conquistas from './pages/Conquistas';
import Feed from './pages/Feed';
import IA from './pages/IA';
import Fornecedores from './pages/Fornecedores';
import MentorDashboard from './pages/mentor/MentorDashboard';
import MentorAlunos from './pages/mentor/MentorAlunos';
import MentorAlunoDetalhe from './pages/mentor/MentorAlunoDetalhe';
import MentorConvites from './pages/mentor/MentorConvites';
import MentorFeed from './pages/mentor/MentorFeed';
import MentorMateriais from './pages/mentor/MentorMateriais';
import MentorTurmas from './pages/mentor/MentorTurmas';
import MeuPerfil from './pages/MeuPerfil';
import TaxaSiscomex from './pages/TaxaSiscomex';
import NCM from './pages/NCM';
import MentorProdutos from './pages/mentor/MentorProdutos';
import MentorNCM from './pages/mentor/MentorNCM';
import MentorNotificacoes from './pages/mentor/MentorNotificacoes';
import FornecedoresDashboard from './pages/mentor/FornecedoresDashboard';
import FornecedoresList from './pages/mentor/FornecedoresList';
import FornecedorDetalhe from './pages/mentor/FornecedorDetalhe';
import FornecedoresImportExport from './pages/mentor/FornecedoresImportExport';
import MentorMercadoLivre from './pages/mentor/MentorMercadoLivre';
import { api } from './utils/api';

function RequireAuth({ role, allow }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',color:'#6B7289',fontSize:13}}>Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  const permitido = role ? (Array.isArray(role) ? role : [role]) : null;
  const roleOk = !permitido || permitido.includes(user.role);
  const allowOk = allow ? allow(user) : false;
  if (!roleOk && !allowOk) {
    const home = user.role === 'mentor' ? '/mentor/dashboard'
      : user.role === 'mentor_fornecedores' ? '/mentor/fornecedores'
      : '/dashboard';
    return <Navigate to={home} replace />;
  }
  return <Outlet />;
}

function AppLayout() {
  const { token, user } = useAuth();
  const [notifCount, setNotifCount] = useState(0);

  useEffect(() => {
    if (user?.role === 'mentor') {
      api.get('/mentor/notificacoes', token)
        .then(data => setNotifCount(data.filter(n=>!n.lido).length))
        .catch(()=>{});
    }
  }, [token, user]);

  return (
    <div style={{display:'flex',height:'100vh',overflow:'hidden'}}>
      <Sidebar notifCount={notifCount} />
      <main style={{flex:1,overflowY:'auto',background:'#F4F5F9'}}>
        <Outlet />
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/convite/:token" element={<Convite />} />

          <Route element={<RequireAuth role="aluno" />}>
            <Route element={<AppLayout />}>
              <Route path="/dashboard"       element={<Dashboard />} />
              <Route path="/operacoes"       element={<Operacoes />} />
              <Route path="/operacoes/:id"   element={<Jornada />} />
              <Route path="/conquistas"      element={<Conquistas />} />
              <Route path="/feed"            element={<Feed />} />
              <Route path="/ia"              element={<IA />} />
              <Route path="/perfil"          element={<MeuPerfil />} />
              <Route path="/taxa-siscomex"   element={<TaxaSiscomex />} />
              <Route path="/ncm"              element={<NCM />} />
              <Route path="/fornecedores"    element={<Fornecedores />} />
            </Route>
          </Route>

          <Route element={<RequireAuth role="mentor" />}>
            <Route element={<AppLayout />}>
              <Route path="/mentor/dashboard"              element={<MentorDashboard />} />
              <Route path="/mentor/alunos"                 element={<MentorAlunos />} />
              <Route path="/mentor/alunos/:id"             element={<MentorAlunoDetalhe />} />
              <Route path="/mentor/convites"               element={<MentorConvites />} />
              <Route path="/mentor/turmas"                 element={<MentorTurmas />} />
              <Route path="/mentor/feed"                   element={<MentorFeed />} />
              <Route path="/mentor/materiais"              element={<MentorMateriais />} />
              <Route path="/mentor/perfil"                 element={<MeuPerfil />} />
              <Route path="/mentor/taxa-siscomex"          element={<TaxaSiscomex />} />
              <Route path="/mentor/produtos"               element={<MentorProdutos />} />
              <Route path="/mentor/ncm"                    element={<MentorNCM />} />
              <Route path="/mentor/mercado-livre"          element={<MentorMercadoLivre />} />
              <Route path="/mentor/notificacoes"           element={<MentorNotificacoes />} />
            </Route>
          </Route>

          <Route element={<RequireAuth role={["mentor","mentor_fornecedores"]} allow={u => u.role === 'aluno' && u.acesso_fornecedores_total} />}>
            <Route element={<AppLayout />}>
              <Route path="/mentor/fornecedores"           element={<FornecedoresDashboard />} />
              <Route path="/mentor/fornecedores/lista"     element={<FornecedoresList />} />
              <Route path="/mentor/fornecedores/importar"  element={<FornecedoresImportExport />} />
              <Route path="/mentor/fornecedores/:id"       element={<FornecedorDetalhe />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
